module.exports = __webpack_public_path__ + "images/very-gifted-268707e31e4489403c5c2c8b4bd8b6b2.png";